export default{
  name: '证书管理',
  permissionsKey:"YY-ZSGL",
  icon: 'fa fa-envelope-open',
  children:{
    classList:{
      name: '证书列表',
      permissionsKey: "YY-ZSGL-ZSLB",
      path: '/certificate',
    }
  }
}
